import React from 'react'
import ContentLoader from 'react-content-loader'
import PropTypes from 'prop-types'

const CategoryListSkeleton = ({
  height = 405,
  width = 270,
  speed = 1,
  primaryColor = '#f3f3f3',
  secondaryColor = '#ecebeb',
  isFullSize = false
}) => (
  <div className={isFullSize ? 'xs-12' : 'xs-12 lg-9'}>
    <ContentLoader
      height={height}
      width={width}
      speed={speed}
      backgroundColor={primaryColor}
      foregroundColor={secondaryColor}
      uniqueKey='cl-content-loader'
      className='xs-hidden md-block'>
      <rect x='0' y='10' width='125' height='18' />
      <rect x='0' y='32' width='183' height='65' />
      <rect x='189' y='32' width='87' height='65' />
      <rect x='0' y='115' width='125' height='15' />
      <rect x='0' y='134' width='270' height='65' />
      <rect x='0' y='215' width='125' height='15' />
      <rect x='0' y='235' width='87' height='65' />
      <rect x='92' y='235' width='87' height='65' />
      <rect x='184' y='235' width='87' height='65' />
      <rect x='0' y='320' width='125' height='15' />
      <rect x='0' y='340' width='87' height='65' />
      <rect x='92' y='340' width='183' height='65' />
    </ContentLoader>
    <ContentLoader
      height={height}
      width={width}
      speed={speed}
      backgroundColor={primaryColor}
      foregroundColor={secondaryColor}
      uniqueKey='cl-mobile-content-loader'
      className='md-hidden'>
      <rect x='0' y='20' rx='0' ry='0' width='125' height='30' />
      <rect x='0' y='60' rx='0' ry='0' width='210' height='140' />
      <rect x='220' y='60' rx='0' ry='0' width='125' height='140' />
      <rect x='0' y='220' rx='0' ry='0' width='270' height='55' />
      <rect x='0' y='285' rx='0' ry='0' width='270' height='55' />
      <rect x='0' y='350' rx='0' ry='0' width='270' height='55' />
    </ContentLoader>
  </div>
)

CategoryListSkeleton.defaultProps = {
  height: 405,
  width: 270,
  speed: 1,
  primaryColor: '#f3f3f3',
  secondaryColor: '#ecebeb',
  isFullSize: false
}

CategoryListSkeleton.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  speed: PropTypes.number,
  primaryColor: PropTypes.string,
  secondaryColor: PropTypes.string,
  isFullSize: PropTypes.bool
}

export default CategoryListSkeleton
